import(/* webpackMode: "eager" */ "/srv/apps/financecareers/releases/1b9961d-202611040312/src/app/global-error.tsx");
